// extracted by mini-css-extract-plugin
module.exports = {"docContainer":"TimelineMobile_docContainer__3bzbx","date":"TimelineMobile_date__1S7pg","title":"TimelineMobile_title__kyrP7","description":"TimelineMobile_description__22Wlx"};